<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        router-link.button-previous.mr-2(to="/administracion/id/role")
          i.fas.fa-chevron-left
        h1.m-0.d-inline-block.align-middle
          i Crear Rol
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Nombre
                  input.col.form-control(type="text" v-model="name" maxlength='100' placeholder='ingresa nombre' title='ingresa tu nombre')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Descripción
                  textarea.form-control(v-model="description" maxlength='100' rows="3" placeholder='ingresa descripción' title='Descripción')
                  .col-auto.form-group.align-items-center.mb-0.pr-0
                //- .col-12
                //-   b-button(@click="addTriplet")
                //-     i.fas.icon-plus

            .card.p-0(v-for="(triplet, index) in triplets")
              .col.row.align-items-start
                label.font-weight-bold.col.pl-0.m-0 Viaje
                .col.px-0.ad_select
                  select(v-model='triplet.travel', @change='getSegments($event, index)')
                    option(:value="null" disabled) Selecciona Viaje
                    option(:value="travel.value" v-for="travel in todosMultiTravel", :key="travel.value") {{travel.label}}

              .col.row.align-items-start
                label.font-weight-bold.col.pl-0.m-0 Segmento
                .col.px-0.ad_select
                  select(v-model='triplet.segment', @change='getProducts($event, index)')
                    option(:value="null" disabled) Selecciona Segmento
                    option(:value="segment.value" v-for="segment in todosMultiSegment[index]", :key="segment.value") {{segment.label}}

              .col.row.align-items-start
                label.col.pl-0.m-0 Productos
                .col.px-0.ad_select
                  select(v-model='triplet.product')
                    option(:value="null" disabled) Selecciona Producto
                    option(:value="product.value" v-for="product in todosMultiProducts[index]", :key="product.value") {{product.label}}
              //- .col-12
              //-   b-button(@click="subsTriplet(index)")
              //-     i.fas.icon-minus    
          .d-flex.flex-row.mt-5
            .col-auto.stepper-button.previous
              router-link(to="/administracion/id/kpi-adherencia")
                i.material-icons
                span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="addRol()")
              span Guardar
              i.material-icons


</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'AdministracionRoleCreate',
  components: {
     Multiselect
  },
  data () {
    return {
      name: null,
      description: null,
      goal: null,
      kpipercentage: null,
      selectedMultiRole: [],
      todosMultiRole: [],
      selectedMultiTravel: [],
      todosMultiTravel: [],
      selectedMultiSegment: [],
      todosMultiSegment: [],
      selectedMultiProducts: [],
      todosMultiProducts: [],
      triplets: [{travel: null, segment: null, product: null}]
    }
  },
  methods: {
    ...mapActions('user', [
      'insertUser',
      'getUsers',
      'getRoles'
    ]),
    ...mapActions('role', [
      'createRole'
    ]),
    ...mapActions('travel', [
      'travelList'
    ]),
    ...mapActions('segment', [
      'ByTravelIds', 'segmentList', 'ByTravelId'
    ]),
    ...mapActions('product', [
      'BySegmentIds', 'productList', 'BySegmentId'
    ]),
    getValuesOfMultiSelect(valuesMultiSelect) {
      return valuesMultiSelect.map(values => values.value)
    },
    getItemsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: p.name}))
    },
    getSegmentsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: `${p.name} (${p.travel.name})`}))
    },
    getProductsToMultiSelectLoad(items) {
      return items.map(p => ({value: p.id, label: `${p.name} (${p.segment.name}/${p.segment.travel.name})`}))
    },
    getSelectedAfterChangedParent(todos, oldSelectedItems) {
      return todos.filter(t => oldSelectedItems.map(o => o.value).includes(t.value))
    },
    getRolFromProps() {
      const vm = this
      return {
        name: vm.name,
        description: vm.description,
        triplets: vm.triplets     
      }
    },
    loadControls() {
      const vm = this
      const loading = vm.$toast.loading('Cargando ...')
      vm.loadTravels()
      loading.hide()
    },
    loadTravels() {
      const vm = this
      vm.travelList({}).then(response => {
        vm.todosMultiTravel = vm.getItemsToMultiSelectLoad(response)              
      })
    },
    getSegments($event, index) {
      const vm = this
      if (vm.triplets[index].travel !== null) {
        vm.ByTravelId({travel: vm.triplets[index].travel}).then((response) => {          
          vm.todosMultiSegment[index] = vm.getSegmentsToMultiSelectLoad(response)
          vm.$forceUpdate();        
        }, (error) => {
          vm.notify(error)
        })
      }
    },
    getProducts($event, index) {
      const vm = this
      if (vm.triplets[index].segment !== null) {
        vm.BySegmentId({segment: vm.triplets[index].segment}).then(response => {
          vm.todosMultiProducts[index] = vm.getProductsToMultiSelectLoad(response)
          vm.$forceUpdate();
        }, (error) => {
          vm.notify(error)
        })
      }
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    clearInputs() {
      const vm = this
      vm.name = ''
      vm.description = ''
      vm.goal = ''
      vm.kpipercentage = ''
      vm.selectedMultiRole = []
    },
    addRol() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      const data = vm.getRolFromProps()
      if (vm.validate(data)) {        
        vm.createRole(data).then(result => {
          loading.hide()
          // vm.clearInputs()
          vm.notify(false, 'Rol creado')
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
      } else {
        loading.hide()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null && input.length > 0
    },
    isValidInputPer(input) {
      return input >= 0 && input <= 100
    },
    validate(data) {
      const vm = this
      let valid = true
      let missing = ''
      
      if (!vm.isValidInput(data.name)) {
        missing = 'Debe completar el campo nombre'
        valid = false
      } else if (!vm.isValidInput(data.description)) {
        missing = 'Debe completar el campo descripción'
        valid = false
      }

      for (let t of data.triplets) {
        if (t.travel == null || t.segment == null || t.product == null) {
          missing = 'Debe completar los campos de viaje, segmento y producto'
          valid = false;
          break;
        }
      }
      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: missing,
          closeable: true,
          duration: 5000
        })
        return false
      }
    },
    addTriplet() {
      const vm = this
      vm.triplets.push({travel: null, segment: null, product: null})
    },
    subsTriplet(index) {
      const vm = this
      vm.triplets.splice(index, 1)
    }
  },
  mounted() {
    const vm = this;
    vm.loadControls()
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-role-create.vue